import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CRM_MEMBERSHIPS_FEATURE_GROUP } from './group';

export const CRM_MEMBERSHIPS_FEATURES = {
  READ: {
    guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a0300',
    name: 'crm_memberships:read',
    description: 'View the CRM memberships page',
    action: 'read',
    product: 'crm',
    parentGuid: CRM_MEMBERSHIPS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CRM_MEMBERSHIPS_FEATURE_GROUP } from './group';

export const CRM_MEMBERSHIPS_MODULE: FeatureModule = {
  product: 'crm',
  groups: [CRM_MEMBERSHIPS_FEATURE_GROUP],
  features: featureList(CRM_MEMBERSHIPS_FEATURES),
};
